import React, { useState, useEffect } from "react";
import BaseHeader from "../Ui/Header/BaseHeader";

type Props = {
    mode: string;
}

const Header = ({ mode }: Props) => {

    const [isClick, setIsClick] = useState(false);
    const [isIn, setIsIn] = useState(false);
    const [links, setLinks] = useState([
        { name: "Главная", url: "/" },
        { name: "О нас", url: "/AboutUs" },
        { name: "Направления", url: "/#directions" },
        { name: "Инвестиционный бутик", url: "/category/details" },
        { name: "Тарифы", url: "/articles/tariffs" },
        { name: "Контакты", url: "/ContactsInMain" },
    ])
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(max-width: 1025px)");

        const handleChange = (e: MediaQueryListEvent | MediaQueryList) => {
            setIsMobile(e.matches);
        };

        handleChange(mediaQuery);

        mediaQuery.addEventListener("change", handleChange);

        return () => mediaQuery.removeEventListener("change", handleChange);
    }, []);
    

    return (
        <>
            <div className="menuList">
                {links.map(link => 
                    link.name === "Направления"
                        ? isMobile ? (
                            <>
                                <a onClick={() => setIsClick(prev => !prev)} className="list-item" id="directions-open-button">Направления <img id="openCloseIcon" src="/main-images/closeOpenMenuIcon.svg" /> </a>
                                <div className="directionsList"
                                    style={{ display: isClick ? "flex" : "none" }}
                                >
                                    <a target="_blank" className="list-item" href="https://art.viomitra.ru/">
                                        <h5><span>ART.</span> VIOMITRA</h5>
                                        <p>Пространство для творческих людей и&nbsp;утончённых инвесторов, где можно купить и&nbsp;продать предметы искусства, антиквариат и&nbsp;другие уникальные товары</p>
                                    </a>

                                    <a target="_blank" className="list-item" href="https://invest.viomitra.ru/">
                                        <h5><span>INVEST.</span> VIOMITRA</h5>
                                        <p>Площадка, которая открывает секрет успешных коммерческих торгов через аукцион с&nbsp;широкой аудиторией инвесторов из&nbsp;всех регионов России. Каждая ставка&nbsp;&mdash; шаг к&nbsp;новым возможностям</p>
                                    </a>

                                    <a target="_blank" className="list-item" href="https://china.viomitra.ru/">
                                        <h5><span>CHINA.</span> VIOMITRA</h5>
                                        <p>
                                            Пространство для сотрудничества китайских и&nbsp;российских компаний:
                                            так, коммерческие компании могут производить закупки для бизнеса у&nbsp;зарубежных производителей
                                        </p>
                                    </a>

                                    <a target="_blank" className="list-item" href="https://bankrot.viomitra.ru/">
                                        <h5><span>BANKROT.</span> VIOMITRA</h5>
                                        <p>Топ-агрегатор торгов по&nbsp;банкротству с&nbsp;разнообразными активами и&nbsp;ежедневными обновлениями</p>
                                    </a>

                                    <a target="_blank" className="list-item" href="https://rosim.viomitra.ru/">
                                        <h5><span>GOV.</span> VIOMITRA</h5>
                                        <p>Продажа имущества - Приватизация, аренда, конфискованное и арестованное имущество, непрофильные активы</p>
                                    </a>

                                    <a target="_blank" className="list-item" href="https://dev.viomitra.ru/">
                                        <h5><span>DEV.</span> VIOMITRA</h5>
                                        <p>Современные IT-решения для вашего <br /> бизнеса, созданные командой <br /> профессионалов с&nbsp;опытом &gt; 15&nbsp;лет</p>
                                    </a>
                                </div>
                            </>
                        ): (
                                <a
                                    key = {link.url}
                                    className={window.location.pathname.replace(/\/$/, '') === link.url.replace(/\/$/, '') ? "link active" : "link"}
                                    href={link.url}
                                    onMouseEnter={() => setIsIn(true)}
                                    onMouseLeave={() => setIsIn(false)}
                                >
                                    {link.name}
                                    {!isMobile && <div className="stroke"></div>}
                                </a>
                        )

                        : <a
                            key={link.url}
                            className={window.location.pathname.replace(/\/$/, '') === link.url.replace(/\/$/, '') ? "link active" : "link"}
                            href={link.url}
                        >
                            {link.name}
                            {!isMobile && <div className="stroke"></div>}
                        </a>

                )}
            </div>


            {isMobile ? (
                <div className="mega-box" id="megaBoxDescriptions"
                    onMouseEnter={() => setIsIn(true)}
                    onMouseLeave={() => setIsIn(false)}
                    style={{ display: isIn ? "flex" : "none" }}
                >
                    <div className="mega-box-container">
                        <div className="mega-title">
                            <h4>Направления</h4>
                            <p>VIOMITRA — свежий взгляд на мир онлайн-аукционов! Любая сделка превращается в увлекательное путешествие с бесчисленными возможностями. Просто выбери своё направление и окунись в игру вместе с нами!</p>
                        </div>
                        <div className="mega-item">
                            <a target="_blank" className="mega-link" href="https://art.viomitra.ru/">
                                <h4><span>ART.</span> VIOMITRA</h4>
                                <p>Пространство для творческих людей и&nbsp;утончённых инвесторов, где можно купить и&nbsp;продать предметы искусства, антиквариат и&nbsp;другие уникальные товары</p>
                            </a>
                            <a target="_blank" className="mega-link" href="https://invest.viomitra.ru/">
                                <h4><span>INVEST.</span> VIOMITRA</h4>
                                <p>Площадка, которая открывает секрет успешных коммерческих торгов через аукцион с&nbsp;широкой аудиторией инвесторов из&nbsp;всех регионов России. Каждая ставка&nbsp;&mdash; шаг к&nbsp;новым возможностям</p>
                            </a>
                            <a target="_blank" className="mega-link mega-link-last" href="https://china.viomitra.ru/">
                                <h4><span>CHINA.</span> VIOMITRA</h4>
                                <p>
                                    Пространство для сотрудничества китайских и&nbsp;российских компаний:
                                    так, коммерческие компании могут производить закупки для бизнеса у&nbsp;зарубежных производителей
                                </p>
                            </a>
                            <a target="_blank" className="mega-link" href="https://bankrot.viomitra.ru/">
                                <h4><span>BANKROT.</span> VIOMITRA</h4>
                                <p>Топ-агрегатор торгов по&nbsp;банкротству с&nbsp;разнообразными активами и&nbsp;ежедневными обновлениями</p>
                            </a>
                            <a target="_blank" className="mega-link" href="https://rosim.viomitra.ru/">
                                <h4><span>GOV.</span> VIOMITRA</h4>
                                <p>Цифровая платформа, обеспечивающая удовлетворение всех потребностей Росимущества, ФГУП и МУП.</p>
                            </a>
                            <a target="_blank" className="mega-link" href="https://dev.viomitra.ru/">
                                <h4><span>DEV.</span> VIOMITRA</h4>
                                <p>Современные IT-решения для вашего <br /> бизнеса, созданные командой <br /> профессионалов с&nbsp;опытом &gt; 15&nbsp;лет</p>
                            </a>
                        </div>
                    </div>
                </div>
            ): (
                <></>
            )}
            
        </>
    )
}

export default Header;